'use client';

import React from 'react';

type Feature = {
  title: string;
  description: string;
  icon: React.ReactNode;
  borderColor: string;
  shadowColor: string;
  bgColor: string;
  iconBgColor: string;
};

type FeatureCardProps = {
  feature: Feature;
  index: number; // changed from delay string to index number
};

const features: Feature[] = [
  {
    title: 'No Sign-Up',
    description:
      'Just pick a display name and start chatting. No email, no phone number, no account needed.',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.20006 16.2L4.01166 15.63L4.27326 15.5436L4.50966 15.6864L4.20006 16.2ZM1.80006 13.8L2.30526 13.476L2.46006 13.7184L2.36886 13.9896L1.80006 13.8ZM0.60006 17.388L0.78846 17.9592C0.682659 17.9942 0.569199 17.9991 0.460796 17.9732C0.352396 17.9473 0.253336 17.8918 0.174721 17.8128C0.0961075 17.7338 0.0410461 17.6345 0.015707 17.526C-0.00963211 17.4175 -0.00424767 17.304 0.0312595 17.1984L0.60006 17.388ZM4.50966 15.6864C5.65686 16.3764 7.49166 16.7892 9.00006 16.7892V17.9892C7.33806 17.9892 5.27286 17.5452 3.89046 16.7136L4.50966 15.6864ZM9.00006 16.788C13.3081 16.788 16.8001 13.2984 16.8001 8.9928H18.0001C17.9988 11.3789 17.05 13.6669 15.3623 15.3537C13.6746 17.0404 11.3862 17.988 9.00006 17.988V16.788ZM16.8001 8.9928C16.7985 6.92515 15.976 4.94393 14.5134 3.48245C13.0508 2.02096 11.0677 1.2 9.00006 1.2V0C11.386 -5.30202e-07 13.6742 0.947387 15.3619 2.63392C17.0496 4.32045 17.9985 6.60689 18.0001 8.9928H16.8001ZM9.00006 1.2C4.69206 1.2 1.20006 4.6896 1.20006 8.994H6.10352e-05C0.00165176 6.60809 0.950565 4.32045 2.63822 2.63392C4.32588 0.947387 6.61415 -5.30202e-07 9.00006 0V1.2ZM1.20006 8.994C1.20006 10.5912 1.55526 12.3036 2.30526 13.476L1.29486 14.124C0.376862 12.69 6.10352e-05 10.7244 6.10352e-05 8.994H1.20006ZM4.38846 16.77L0.78846 17.9592L0.411661 16.8192L4.01166 15.6312L4.38846 16.77ZM0.0312595 17.1984L1.23126 13.6104L2.36886 13.9896L1.16886 17.5788L0.0312595 17.1984Z" fill="#F8FAFC"/>
      </svg>
    ),
    borderColor: 'border-[#059669]',
    shadowColor: '#059669',
    bgColor: 'bg-[#059669]',
    iconBgColor: 'bg-[#059669]',
  },
  {
    title: '80+ Languages',
    description:
      'Send in English, they read in Japanese. Translations happen instantly and invisibly.',
    icon: (
      <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.9989 14.6859L13.5712 6.3832C13.5079 6.22987 13.4005 6.09879 13.2626 6.00655C13.1247 5.91431 12.9626 5.86507 12.7967 5.86507C12.6308 5.86507 12.4687 5.91431 12.3308 6.00655C12.1929 6.09879 12.0855 6.22987 12.0222 6.3832L8.59447 14.6859C8.55185 14.7878 8.52977 14.897 8.52949 15.0074C8.52921 15.1178 8.55074 15.2271 8.59285 15.3291C8.63496 15.4312 8.69682 15.5239 8.77486 15.6019C8.85291 15.68 8.94561 15.7419 9.04764 15.784C9.14967 15.8261 9.25901 15.8476 9.36939 15.8474C9.47977 15.8471 9.58901 15.825 9.69084 15.7824C9.79266 15.7398 9.88506 15.6775 9.96273 15.5991C10.0404 15.5206 10.1018 15.4276 10.1434 15.3254L10.8415 13.6348H14.7518L15.4499 15.3254C15.5132 15.4788 15.6206 15.61 15.7585 15.7022C15.8965 15.7945 16.0587 15.8438 16.2246 15.8438C16.3623 15.8437 16.4978 15.8097 16.6192 15.7447C16.7407 15.6798 16.8442 15.5859 16.9207 15.4715C16.9972 15.357 17.0443 15.2255 17.0579 15.0884C17.0715 14.9514 17.0511 14.8132 16.9985 14.6859H16.9989ZM11.5336 11.959L12.7969 8.89878L14.0602 11.959H11.5336ZM8.98219 11.2323C9.11236 11.0525 9.16586 10.8284 9.13094 10.6092C9.09602 10.3899 8.97554 10.1935 8.79595 10.0631C8.78833 10.0574 8.22466 9.63917 7.40619 8.74034C8.9163 6.69589 9.77171 4.36998 10.1206 3.27539H11.3496C11.5718 3.27539 11.785 3.18711 11.9421 3.02998C12.0992 2.87284 12.1875 2.65972 12.1875 2.4375C12.1875 2.21528 12.0992 2.00216 11.9421 1.84502C11.785 1.68789 11.5718 1.59961 11.3496 1.59961H6.93164V0.837891C6.93164 0.615668 6.84336 0.402547 6.68623 0.245412C6.52909 0.0882775 6.31597 0 6.09375 0C5.87153 0 5.65841 0.0882775 5.50127 0.245412C5.34414 0.402547 5.25586 0.615668 5.25586 0.837891V1.59961H0.837891C0.615668 1.59961 0.402547 1.68789 0.245412 1.84502C0.0882775 2.00216 0 2.21528 0 2.4375C0 2.65972 0.0882775 2.87284 0.245412 3.02998C0.402547 3.18711 0.615668 3.27539 0.837891 3.27539H8.35034C7.98776 4.30181 7.32012 5.92236 6.3017 7.40238C5.10542 5.81496 4.66096 4.78778 4.65753 4.7794C4.56995 4.57701 4.40611 4.4173 4.20155 4.33492C3.99699 4.25254 3.76819 4.25413 3.56479 4.33934C3.36139 4.42455 3.19978 4.58651 3.11502 4.7901C3.03025 4.99369 3.02917 5.22248 3.112 5.42687C3.13409 5.47942 3.66615 6.73055 5.12523 8.62342C5.16026 8.66874 5.19492 8.71292 5.22958 8.7571C3.73509 10.4462 2.26878 11.494 1.65521 11.8322C1.46011 11.9386 1.31528 12.1181 1.25257 12.3313C1.18985 12.5445 1.21441 12.7739 1.32082 12.969C1.42723 13.1641 1.60679 13.309 1.82 13.3717C2.0332 13.4344 2.26258 13.4098 2.45769 13.3034C2.53995 13.2585 4.30866 12.2793 6.32836 10.0436C7.18605 10.9608 7.77562 11.3934 7.81104 11.4185C7.90016 11.4833 8.00117 11.5298 8.10829 11.5555C8.21541 11.5811 8.32654 11.5854 8.43531 11.5681C8.54409 11.5507 8.64838 11.5121 8.74222 11.4544C8.83605 11.3968 8.9176 11.3211 8.98219 11.2319V11.2323Z" fill="#F8FAFC"/>
      </svg>
    ),
    borderColor: 'border-[#6A35E0]',
    shadowColor: '#6A35E0',
    bgColor: 'bg-[#6A35E0]',
    iconBgColor: 'bg-[#6A35E0]',
  },
  {
    title: 'Context-Aware Translation',
    description:
      'Understands slang, idioms, and cultural context — not just word-by-word substitution.',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.79356 6.07344L7.56881 3.36181C7.85931 2.34681 9.29781 2.34681 9.58831 3.36181L10.3627 6.07344C10.4117 6.24497 10.5036 6.40118 10.6298 6.52733C10.7559 6.65348 10.9122 6.74541 11.0837 6.79444L13.7953 7.56881C14.8103 7.85931 14.8103 9.29781 13.7953 9.58831L11.0837 10.3627C10.9122 10.4117 10.7559 10.5036 10.6298 10.6298C10.5036 10.7559 10.4117 10.9122 10.3627 11.0837L9.58831 13.7953C9.29781 14.8103 7.85931 14.8103 7.56881 13.7953L6.79444 11.0837C6.74541 10.9122 6.65348 10.7559 6.52733 10.6298C6.40118 10.5036 6.24497 10.4117 6.07344 10.3627L3.36181 9.58831C2.34681 9.29781 2.34681 7.85931 3.36181 7.56881L6.07344 6.79444C6.24497 6.74541 6.40118 6.65348 6.52733 6.52733C6.65348 6.40118 6.74541 6.24497 6.79444 6.07344M1.95481 1.82619L2.28381 0.507562C2.32756 0.330812 2.57956 0.330812 2.62331 0.507562L2.95319 1.82619C2.96078 1.85698 2.97659 1.88513 2.99894 1.90763C3.02128 1.93013 3.04932 1.94614 3.08006 1.95394L4.39956 2.28381C4.57631 2.32756 4.57631 2.57869 4.39956 2.62331L3.08006 2.95319C3.04943 2.96091 3.02146 2.97679 2.99913 2.99913C2.97679 3.02146 2.96091 3.04943 2.95319 3.08006L2.62331 4.39956C2.57956 4.57631 2.32756 4.57631 2.28381 4.39956L1.95394 3.08006C1.94621 3.04943 1.93034 3.02146 1.908 2.99913C1.88566 2.97679 1.85769 2.96091 1.82706 2.95319L0.507562 2.62331C0.330812 2.57956 0.330812 2.32756 0.507562 2.28381L1.82706 1.95394C1.8578 1.94614 1.88584 1.93013 1.90819 1.90763C1.93054 1.88513 1.94722 1.85698 1.95481 1.82619ZM14.2048 14.0771L14.5338 12.7576C14.5776 12.5808 14.8287 12.5808 14.8733 12.7576L15.2032 14.0771C15.2109 14.1077 15.2268 14.1357 15.2491 14.158C15.2715 14.1803 15.2994 14.1962 15.3301 14.2039L16.6496 14.5338C16.8263 14.5776 16.8263 14.8287 16.6496 14.8733L15.3301 15.2032C15.2994 15.2109 15.2715 15.2268 15.2491 15.2491C15.2268 15.2715 15.2109 15.2994 15.2032 15.3301L14.8733 16.6496C14.8296 16.8263 14.5784 16.8263 14.5338 16.6496L14.2039 15.3301C14.1962 15.2994 14.1803 15.2715 14.158 15.2491C14.1357 15.2268 14.1077 15.2109 14.0771 15.2032L12.7576 14.8733C12.5808 14.8296 12.5808 14.5776 12.7576 14.5338L14.0771 14.2039C14.1077 14.1962 14.1357 14.1803 14.158 14.158C14.1803 14.1357 14.1971 14.1077 14.2048 14.0771Z" stroke="#F8FAFC" strokeWidth="0.75" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    borderColor: 'border-[#FF803E]',
    shadowColor: '#FF803E',
    bgColor: 'bg-[#FF803E]',
    iconBgColor: 'bg-[#FF803E]',
  },
  {
    title: 'Group Chats',
    description:
      'Create rooms for your hostel, tour group, or travel crew. Everyone reads in their own language.',
    icon: (
      <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.75 13.0004V12.1254C0.75 11.1972 1.11875 10.3069 1.77513 9.65056C2.4315 8.99419 3.32174 8.62544 4.25 8.62544H7.75C8.67826 8.62544 9.5685 8.99419 10.2249 9.65056C10.8813 10.3069 11.25 11.1972 11.25 12.1254V13.0004M16.5 13.0004V12.1254C16.5 11.1972 16.1313 10.3069 15.4749 9.65056C14.8185 8.99419 13.9283 8.62544 13 8.62544M10.8125 0.899188C11.2084 0.75971 11.6319 0.717186 12.0476 0.775183C12.4633 0.83318 12.859 0.990007 13.2015 1.23251C13.5441 1.47502 13.8235 1.79613 14.0164 2.16891C14.2092 2.5417 14.3098 2.95529 14.3098 3.375C14.3098 3.79471 14.2092 4.2083 14.0164 4.58109C13.8235 4.95387 13.5441 5.27499 13.2015 5.51749C12.859 5.75999 12.4633 5.91682 12.0476 5.97482C11.6319 6.03282 11.2084 5.99029 10.8125 5.85081M8.625 3.37544C8.625 4.07163 8.34844 4.73931 7.85616 5.23159C7.36387 5.72388 6.69619 6.00044 6 6.00044C5.30381 6.00044 4.63613 5.72388 4.14384 5.23159C3.65156 4.73931 3.375 4.07163 3.375 3.37544C3.375 2.67924 3.65156 2.01157 4.14384 1.51928C4.63613 1.027 5.30381 0.750438 6 0.750438C6.69619 0.750438 7.36387 1.027 7.85616 1.51928C8.34844 2.01157 8.625 2.67924 8.625 3.37544Z" stroke="#F8FAFC" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    borderColor: 'border-[#E1B840]',
    shadowColor: '#E1B840',
    bgColor: 'bg-[#E1B840]',
    iconBgColor: 'bg-[#E1B840]',
  },
  {
    title: 'Real-Time',
    description:
      'Messages and translations arrive instantly. No waiting, no refresh — just seamless conversation.',
    icon: (
      <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.57838 15.4916L10.4275 8.484H5.90644L6.72587 2.06978L1.49842 9.61426H5.42608L4.57838 15.4916ZM4.1308 10.7445H0.756975C0.450298 10.7445 0.228014 10.6108 0.0901221 10.3433C-0.0477695 10.0758 -0.027425 9.81922 0.151156 9.57357L6.51338 0.356311C6.62867 0.194307 6.77184 0.0869324 6.94288 0.0341869C7.11393 -0.0185585 7.29477 -0.0102701 7.48541 0.0590524C7.67604 0.128375 7.81356 0.242908 7.89795 0.402651C7.98235 0.562394 8.01324 0.736831 7.99063 0.925962L7.19606 7.35375H11.2492C11.5656 7.35375 11.7898 7.49804 11.9217 7.78664C12.0543 8.07523 12.0185 8.34272 11.8143 8.58912L4.73436 17.0695C4.6138 17.2126 4.46837 17.3042 4.29808 17.3441C4.12703 17.3833 3.95825 17.3656 3.79172 17.291C3.6252 17.2171 3.49785 17.1052 3.40969 16.9553C3.32229 16.8054 3.29026 16.6358 3.31362 16.4467L4.1308 10.7445Z" fill="#F8FAFC"/>
      </svg>
    ),
    borderColor: 'border-[#E84B4B]',
    shadowColor: '#E84B4B',
    bgColor: 'bg-[#E84B4B]',
    iconBgColor: 'bg-[#E84B4B]',
  },
  {
    title: 'Private & Anonymous',
    description:
      'No tracking, no data selling. Your conversations are yours. Delete anytime.',
    icon: (
      <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.625 8.125C14.625 12.6344 11.505 16.8512 7.3125 17.875C3.12 16.8512 0 12.6344 0 8.125V3.25L7.3125 0L14.625 3.25V8.125ZM7.3125 16.25C10.3594 15.4375 13 11.8138 13 8.30375V4.30625L7.3125 1.77125L1.625 4.30625V8.30375C1.625 11.8138 4.26562 15.4375 7.3125 16.25Z" fill="#F8FAFC"/>
      </svg>
    ),
    borderColor: 'border-[#64748B]',
    shadowColor: '#64748B',
    bgColor: 'bg-[#64748B]',
    iconBgColor: 'bg-[#64748B]',
  },
];

/* -------------------- Feature Card -------------------- */

const FeatureCard: React.FC<FeatureCardProps> = ({ feature, index }) => {
  return (
    <div
      className={`group bg-transparent rounded-lg lg:px-6 lg:py-10 px-3 py-8 border ${feature.borderColor}
      flex flex-col items-center text-center
      transform transition-all duration-300
      hover:scale-105 hover:-translate-y-2 hover:shadow-2xl
      animate-card`}
      style={{
        boxShadow: `4px 4px 0px 0px ${feature.shadowColor}`,
        animationDelay: `${index * 0.5}s`, // ✅ staggered entry animation delay
      }}
    >
      <div
        className={`${feature.iconBgColor} w-10 h-10 rounded flex items-center justify-center lg:mb-6 mb-4`}
      >
        <span className="text-white">{feature.icon}</span>
      </div>

      <div
        className={`w-full h-[1px] mb-4 transition-all duration-300 group-hover:opacity-100 opacity-0 ${feature.bgColor}`}
      />

      <h3 className="text-[#F8FAFC] font-semibold lg:text-lg text-base mb-3 font-primary">
        {feature.title}
      </h3>

      <p className="text-[#94A3B8] lg:text-sm text-[12px] font-primary">
        {feature.description}
      </p>
    </div>
  );
};

/* -------------------- Main Component -------------------- */

const Travel: React.FC = () => {
  return (
    <section className="bg-[#0F172A] py-16 px-4 md:px-0 lg:px-8">
      <div className="max-w-[95%] mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="sm:text-4xl text-3xl lg:text-5xl font-bold text-[#F8FAFC] mb-6 font-primary">
            Built for the way you travel
          </h2>

          <p className="text-[#94A3B8] font-primary sm:text-base text-sm lg:text-lg">
            Everything you need to connect with anyone, anywhere — without the friction.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:gap-10 lg:gap-8 sm:gap-6 gap-4">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              feature={feature}
              index={index} // ✅ pass index instead of delay string
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Travel;